/**
 * Live ticker — emits the current unix-second once per second.
 * Components $derive their TOTP codes from this single source so we
 * don't duplicate setInterval timers across cards.
 */

class TickerStore {
  now = $state(Math.floor(Date.now() / 1000));
  private handle: number | null = null;
  private _visHandler: (() => void) | null = null;

  start(): void {
    if (this.handle !== null) return;
    if (typeof window === 'undefined') return;

    this._startInterval();

    this._visHandler = () => {
      if (document.hidden) {
        this._stopInterval();
      } else {
        this.now = Math.floor(Date.now() / 1000);
        this._startInterval();
      }
    };
    document.addEventListener('visibilitychange', this._visHandler);
  }

  stop(): void {
    this._stopInterval();
    if (this._visHandler) {
      document.removeEventListener('visibilitychange', this._visHandler);
      this._visHandler = null;
    }
  }

  private _startInterval(): void {
    if (this.handle !== null || typeof window === 'undefined') return;
    this.handle = window.setInterval(() => {
      this.now = Math.floor(Date.now() / 1000);
    }, 1000);
  }

  private _stopInterval(): void {
    if (this.handle !== null && typeof window !== 'undefined') {
      window.clearInterval(this.handle);
      this.handle = null;
    }
  }
}

export const ticker = new TickerStore();
